/* eslint-disable react/no-unescaped-entities */
import React from "react";
import "./NotFound.scss";
import { Link } from "react-router-dom";
import "./NotFound.scss";

function NotFound() {
  return (
    <div className="nf-page spacing">
      <div className="container">
        <div className="inner">
          <h5>
            <b>Sorry! This resource is not found.😕😵‍💫</b>
          </h5>
          <p>The page you are looking for isn't here.</p>
          <Link className="btn" to="/">
            Goto Home Page
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
